import React from "react";
import PropTypes from "prop-types";

import { VideoModalWrapper } from "./styles";
import { Modal, VideoAPI } from "../../Elements";
import { getVideoId } from "@website-builder/utilities-index";

const VideoModalV2 = ({
	show,
	onModalClose,
	url,
	onPlay,
	onPause,
	onStateChange,
}) => {
	let videoId = getVideoId(url);
	return (
		<VideoModalWrapper className="modalContainer">
			<Modal
				className="modalWrapper"
				show={show}
				disableBackdropClick={true}
				onClose={onModalClose}
			>
				<div className="modalBodyCustom">
					<VideoAPI
						videoId={videoId}
						onPlay={onPlay}
						onPause={onPause}
						onStateChange={onStateChange}
						segmentTracking={true}
					/>
				</div>
			</Modal>
		</VideoModalWrapper>
	);
};

VideoModalV2.defaultProps = {
	show: false,
	onModalClose: () => {},
	onPlay: () => {},
	onPause: () => {},
	onStateChange: () => {},
	url: "",
};

VideoModalV2.propTypes = {
	show: PropTypes.bool.isRequired,
	onModalClose: PropTypes.func,
	onPlay: PropTypes.func,
	onPause: PropTypes.func,
	onStateChange: PropTypes.func,
	url: PropTypes.string,
};

export default VideoModalV2;
